import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { BorderStyleEnum, BorderTypeEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createHorizontalLine(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): HorizontalLineInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.HorizontalLine,
      parentId,
      masterBlockId,
    ),
    border: {
      width: 1,
      style: BorderStyleEnum.solid,
      radius: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
      },
      color: 'rgba(68, 68, 68, 1)',
      type: BorderTypeEnum.fullBorder,
    },
  }
}
